"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.customDialogStyle = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _excluded = ["className", "classes", "width", "dialogTitle", "onCancel", "children", "fullScreen"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var customDialogStyle = exports.customDialogStyle = function customDialogStyle(theme) {
  var _closeIcon;
  var _theme$smallScreen = theme.smallScreen,
    smallScreen = _theme$smallScreen === void 0 ? {
      centeredDialogPadding: 0
    } : _theme$smallScreen;
  return {
    MuiDialogBorder: {
      borderTop: '7px solid ' + theme.palette.primary.main
    },
    MuiStyledDialog: {
      '& .MuiDialog-container': {
        '& .MuiDialog-paperWidthMd': {
          maxWidth: 720
        },
        '& .MuiDialogTitle-root': {
          paddingTop: 20,
          paddingBottom: 15,
          '& p, h2': {
            fontSize: 24,
            fontWeight: 'bold',
            letterSpacing: 'normal',
            marginRight: 28
          }
        },
        '& .MuiDialogActions-root': {
          paddingBottom: 24
        },
        '& .MuiDialogTitle-root, .MuiDialogContent-root, .MuiDialogActions-root': {
          paddingLeft: smallScreen.centeredDialogPadding,
          paddingRight: smallScreen.centeredDialogPadding,
          '& p': {
            fontSize: 15,
            letterSpacing: 'normal'
          }
        }
      },
      '& .MuiButton-root': {
        height: 40,
        textTransform: 'none',
        minWidth: 140
      }
    },
    stickyDialog: {
      '& .MuiDialog-container': {
        '& .MuiDialogTitle-root': {
          paddingTop: 25,
          paddingBottom: 8
        }
      },
      '& .MuiButton-root': {
        width: '100%',
        height: 56,
        minWidth: 64
      }
    },
    closeIcon: (_closeIcon = {
      position: 'absolute',
      right: 28,
      top: 28
    }, _defineProperty(_closeIcon, theme.breakpoints.down('xs'), {
      right: 20,
      top: 30
    }), _defineProperty(_closeIcon, '&:hover', {
      cursor: 'pointer'
    }), _closeIcon)
  };
};
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'xl'
})((0, _styles.withStyles)(customDialogStyle, {
  name: 'CustomDialog'
})(function (_ref) {
  var className = _ref.className,
    classes = _ref.classes,
    width = _ref.width,
    dialogTitle = _ref.dialogTitle,
    onCancel = _ref.onCancel,
    children = _ref.children,
    fullScreen = _ref.fullScreen,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    maxWidth: width === 'md' || width === 'lg' || width === 'xl' ? 'md' : 'sm',
    fullWidth: true,
    classes: {
      paper: classes.MuiDialogBorder,
      root: classes.MuiStyledDialog
    },
    className: className + ' ' + (width === 'xs' ? classes.stickyDialog : ''),
    fullScreen: fullScreen
  }, props), /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    id: "alert-dialog-title"
  }, dialogTitle, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: classes.closeIcon,
    onClick: onCancel
  }, "close")), children);
}));